import { lazy } from 'react'

export const ContentBackground = lazy(() => import('./component'))
